/**
 * 全局埋点工具
 * 用于项目中各模块的日志埋点上报
 */
import SlsTracker from '@aliyun-sls/web-track-browser';
import { LOGINWAY_URL, MONITOR_PROJECT_NAME } from '@/config/gatewayUrl';
import { APP_MODE } from 'ice';
import { formatDate } from './formatDate';
import { getUuid } from './base';

/**
 * 埋点参数接口
 */
export interface TrackerReportItem {
  id?: string;
  action?: string;
  address?: string;
  appname?: string;
  domain?: string;
  endTime?: string;
  result?: string;
  source?: string;
  startTime?: string;
  url?: string;
  inParams?: object;
  consignmentNo?: string;
  fileName?: string; // 文件名
  isEnter?: string;
  EnterTime?: number;
  warehouseCode?: string;
  user?: string;
  skuScanInfo?: any;
  enterSkuList?: string[];
  alarm?: string;
  allResult?: any[];
  snCodeMessage?: object;
}

// 初始化埋点tracker
const opts = {
  host: LOGINWAY_URL,
  project: MONITOR_PROJECT_NAME,
  logstore: 'gfn',
};
const tracker = new SlsTracker(opts);

/**
 * 埋点日志上报
 * @param maidianParams 埋点日志参数
 * @param inParams 入参
 * @param response 响应参数
 */
export const TrackerReport = (maidianParams: TrackerReportItem, inParams?: any, response?: any) => {
  tracker.send({
    address: window.location.pathname,
    appname: 'giws-web',
    domain: window.location.host,
    endTime: formatDate(new Date().getTime()),
    result: JSON.stringify(response?.data || response),
    source: APP_MODE,
    startTime: formatDate(new Date().getTime()),
    inParams,
    ...maidianParams,
  });
};

/**
 * 文件上传成功埋点
 * @param consignmentNo 运单号
 * @param fileName 文件名
 * @param response 响应数据
 */
export const trackFileUploadSuccess = (consignmentNo?: string, fileName?: string, response?: any) => {
  const uuid = getUuid('');
  const maidianParams: TrackerReportItem = {
    id: uuid,
    consignmentNo,
    fileName,
    action: 'onFileUploadSuccess',
  };
  TrackerReport(maidianParams, response);
};

/**
 * 文件上传失败埋点
 * @param consignmentNo 运单号
 * @param fileName 文件名
 * @param response 响应数据
 */
export const trackFileUploadError = (consignmentNo?: string, fileName?: string, response?: any) => {
  const uuid = getUuid('');
  const maidianParams: TrackerReportItem = {
    id: uuid,
    consignmentNo,
    fileName,
    action: 'onFileUploadError',
  };
  TrackerReport(maidianParams, response);
};

/**
 * VAS订单提交成功埋点
 * @param consignmentNo 运单号
 * @param params 提交参数
 * @param response 响应数据
 */
export const trackVASSubmitSuccess = (consignmentNo?: string, params?: any, response?: any) => {
  const uuid = getUuid('');
  const maidianParams: TrackerReportItem = {
    id: uuid,
    consignmentNo,
    action: 'onVASSubmitSuccess',
  };
  TrackerReport(maidianParams, params, response);
};

/**
 * VAS订单提交失败埋点
 * @param consignmentNo 运单号
 * @param params 提交参数
 * @param error 错误信息
 */
export const trackVASSubmitError = (consignmentNo?: string, params?: any, error?: any) => {
  const uuid = getUuid('');
  const maidianParams: TrackerReportItem = {
    id: uuid,
    consignmentNo,
    action: 'onVASSubmitError',
  };
  TrackerReport(maidianParams, params, error);
};
